<template>
  <div class="assist-dialog-mask" v-show="visible" @click="handleMaskClick">
    <div class="assist-dialog-container" @click.stop>
      <!-- 关闭按钮 -->
      <div class="assist-dialog-close" @click="handleClose">
        <svg class="close-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div class="assist-dialog-content">
        <!-- 成功图标 -->
        <img 
          class="success-icon" 
          src="https://p4-ky.wsukwai.com/kos/nlav12119/DRilhtwf_2026-05-22-15-55-33.png" 
          alt="助力成功"
        />

        <!-- 文案区域 -->
        <div class="text-area">
          <div class="title">助力成功</div>
          <div class="description">
            {{ role === 'receiver' ? '好友已' : '恭喜您' }}获得【模板】{{ templateName }}<br />限时24h免费使用导出
          </div>
        </div>

        <!-- 按钮区域 -->
        <div class="button-area">
          <!-- 发送方按钮 -->
          <div 
            v-if="role === 'sender'" 
            class="confirm-button"
            @click="handleConfirm"
          >
            去【快影】使用
          </div>

          <!-- 接收方按钮 -->
          <div 
            v-else 
            class="confirm-button"
            @click="handleConfirm"
          >
            查看更多模板
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import kylogger from '@ky/sdk/dist/log/kylogger';

export default {
  name: 'AssistSuccessDialog',
  props: {
    // 显示/隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 用户角色：'sender' | 'receiver'
    role: {
      type: String,
      default: 'receiver',
      validator: (value) => !value || ['sender', 'receiver'].includes(value)  // 允许空值
    },
    // 模板名称
    templateName: {
      type: String,
      default: '模板名称'
    },
    // 模板ID
    mvId: {
      type: String,
      default: ''
    },
    // 关闭回调
    onClose: {
      type: Function,
      default: () => {}
    },
    // 确认按钮回调
    onConfirm: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    // 处理蒙层点击
    handleMaskClick() {
      console.log('[AssistDialog] 点击蒙层');
      this.handleClose();
    },
    
    // 处理关闭
    handleClose() {
      console.log('[AssistDialog] 关闭弹窗');
      this.onClose();
      this.trackDialogClick('close');
    },
    
    // 处理确认按钮
    handleConfirm() {
      console.log('[AssistDialog] 点击确认按钮, role:', this.role);
      this.onConfirm();
      const btnName = this.role === 'sender' ? '去【快影】使用' : '查看更多模板';
      this.trackDialogClick(btnName);
    },
    
    // 埋点：弹窗点击
    trackDialogClick(btnName) {
      const userRule = this.role === 'sender' ? 'origin' : 'target';
      kylogger.collect(
        'CLICK', 
        'FRIEND_HELP_SUCCESS', 
        {
          btn_name: btnName,
          mv_id: this.mvId || '',
          user_rule: userRule
        }, 
        {
          urlPage: {
              page: 'MV_SHARE_H5',
          },
        }
      );
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        console.log('[AssistDialog] 弹窗曝光, role:', this.role);
        const userRule = this.role === 'sender' ? 'origin' : 'target';
        kylogger.collect(
          'SHOW', 
          'FRIEND_HELP_SUCCESS', 
          {
            mv_id: this.mvId || '',
            user_rule: userRule
          }, 
          {
            urlPage: {
                page: 'MV_SHARE_H5',
            },
          }
        );
      };
    }
  }
};
</script>

<style lang="less" scoped>
.assist-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.assist-dialog-container {
  position: relative;
  width: 5.6rem; // 280px
  background: #FFFFFF;
  border-radius: 0.24rem; // 12px
  box-sizing: border-box;
  padding: 0.64rem 0.48rem; // 32px 24px
  display: flex;
  flex-direction: column;
  align-items: center;
}

.assist-dialog-close {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.48rem;
  height: 0.48rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  .close-icon {
    width: 0.32rem;
    height: 0.32rem;
  }
  
  &:active {
    opacity: 0.6;
  }
}

.assist-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.48rem; // 24px
}

.success-icon {
  width: 2.12rem; // 106px
  height: 2.6rem; // 130px
  object-fit: contain;
}

.text-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.16rem; // 8px
  
  .title {
    font-size: 0.36rem; // 18px
    line-height: 0.52rem; // 26px
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #222222;
    text-align: center;
  }
  
  .description {
    font-size: 0.28rem; // 14px
    line-height: normal;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #666666;
    text-align: center;
    white-space: pre-wrap;
  }
}

.button-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.confirm-button {
  width: 3.36rem; // 168px
  height: 0.96rem; // 48px
  border-radius: 0.56rem; // 28px
  background: #FE3666;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.3rem; // 15px
  line-height: 0.46rem; // 23px
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #FFFFFF;
  cursor: pointer;
  user-select: none;
  
  &:active {
    opacity: 0.8;
  }
}
</style>
